import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from "@angular/core";

@Component({
  selector: 'app-cbo-select',
  templateUrl: './cbo-select.component.html',
  styleUrls: ['./cbo-select.component.scss']
})

export class CboSelectComponent <T extends { name: string }> {

  @Input() url : string = '';
  
  picked: T;

  @Input()
  label: string;
  @Input()
  options: T[];

  @ContentChild("selectedTemplate", { static: false })
  selectedTemplateRef: TemplateRef<any>;

  @ContentChild("optionTemplate", { static: false })
  optionTemplateRef: TemplateRef<any>;

  @Output()
  selectionChanged = new EventEmitter<T>();

  selectOption(option: T) {
    this.picked = option;
    this.selectionChanged.emit(option);
  }

  ClickCbo (){
    alert('click');
  }
}
